var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJasmine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g850",
    transform: "matrix(0.92871685,0,0,0.92871685,2.4356385,2.1384945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g844",
    transform: "matrix(1.2593529,0,0,1.2593529,-9.6655872,-7.7805845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9",
    className: "st0",
    d: "M59.5,39.2h3.3l0.8-1.1v-8.9h-5V38L59.5,39.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    className: "st0",
    d: "M60.4,56.4h1.4v-6.7h-1.4V56.4z M48.2,47.5l-0.4-1.3l6.4-2.1            l0.4,1.3L48.2,47.5 M56.5,37.2l-4-5.5l1.1-0.8l4,5.5L56.5,37.2 M65.9,37.3l-1.1-0.8l4-5.5l1.1,0.8L65.9,37.3 M74.1,47.6l-6.4-2.1            l0.4-1.3l6.4,2.1L74.1,47.6 M63.9,40l1,3.1l1.3,0.4l8.4-2.7l-1.5-4.7l-8.4,2.7L63.9,40 M64.5,44.4l-2.7,1.9l0,1.4l5.2,7.2l4-2.9            l-5.2-7.2L64.5,44.4 M60.5,46.4l-2.7-1.9l-1.3,0.4L51.3,52l4,2.9l5.2-7.2L60.5,46.4 M57.4,43.1l1-3.1l-0.8-1.1l-8.4-2.7l-1.5,4.7            l8.4,2.7L57.4,43.1 M61.2,21.4c-11.8,0-21.4,9.6-21.4,21.4c0,11.8,9.6,21.4,21.4,21.4c11.8,0,21.4-9.6,21.4-21.4            C82.5,31,73,21.4,61.2,21.4z M61.2,25.8c9.4,0,17,7.6,17,17c0,9.4-7.6,17.1-17,17.1c-9.4,0-17-7.6-17-17.1            C44.1,33.4,51.8,25.8,61.2,25.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasmine);
export default __webpack_public_path__ + "static/media/Jasmine.aa7596c3539b02537e67e15b0714cb24.svg";
export { ForwardRef as ReactComponent };